export const STATUS_LABEL = {
	draft: 'Draft',
	in_progress: 'In Progress',
	submitted: 'Submitted',
	in_review: 'In Review',
	admitted: 'Accepted',
	rejected: 'Rejected',
}

export const fmtDate = value => {
	if (!value) return '—'
	const d = new Date(value)
	if (Number.isNaN(d.getTime())) return String(value)
	return d.toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	})
}

export const fmtDateTime = value => {
	if (!value) return '—'
	const d = new Date(value)
	if (Number.isNaN(d.getTime())) return String(value)
	return (
		d.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
		}) +
		` · ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`
	)
}

export const titleCase = value =>
	String(value || '')
		.replace(/[_-]+/g, ' ')
		.replace(/\b\w/g, m => m.toUpperCase())

export const getIntake = (application, headerInfo) =>
	headerInfo?.intake || application?.intake || application?.primaryIntake || '—'

export const getLocation = (application, headerInfo) =>
	headerInfo?.location || application?.location || application?.country || '—'

export const mapRequirements = (application, requirementsData, headerInfo) => {
	const about = requirementsData?.about || {}
	return [
		{
			label: 'Tuition',
			value: about.tuition || '—',
			icon: 'school',
		},
		{
			label: 'Living Expenses',
			value: about.livingExpenses || '—',
			icon: 'account_balance',
		},
		{
			label: 'Rank / Acceptance',
			value: about.acceptanceRate || '—',
			icon: 'donut_large',
		},
		{
			label: 'Application Deadline',
			value: fmtDate(headerInfo?.deadline || application?.deadline),
			icon: 'event',
		},
	]
}

export const getProgressTone = progress => {
	if (progress >= 100) return 'complete'
	if (progress >= 70) return 'high'
	if (progress >= 35) return 'medium'
	return 'low'
}

export const getInitials = value =>
	String(value || '')
		.split(' ')
		.filter(Boolean)
		.map(part => part[0])
		.slice(0, 2)
		.join('')
		.toUpperCase()
